module.exports = __webpack_public_path__ + "static/media/02-_DSC8989.7fb855db.jpg";